import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { loginUserRequest, registerCustomer, acceptInvite, getUser } from './user/saga';
import { getProjectsRequest, createProjectRequest } from './projects/saga';
import { LOGIN_USER_REQUEST, REGISTER_USER_REQUEST, ACCEPT_INVITE_REQUEST, LOGIN_USER_REQUEST_SUCCESS } from './user/reducer';
import { GET_PROJECTS_REQUEST, CREATE_PROJECT_REQUEST } from './projects/action';
import { GET_EQUIPMENT_REQUEST, CREATE_EQUIPMENT_REQUEST } from './equipment/actions';
import { getEquipment, createEquipment } from "./equipment/saga";
import { GET_USERS_REQUEST, CREATE_USER_REQUEST, DELETE_USER_REQUEST } from './users/actions';
import { getUsers, createUser, deleteUser} from './users/saga';
import { getContractors, createContractor } from './contractors/saga';
import { GET_CONTRACTORS_REQUEST, CREATE_CONTRACTOR_REQUEST, CREATE_CONTRACTOR_REQUEST_SUCCESS } from './contractors/reducer';

export default function* () {
    yield all([
        takeLatest(LOGIN_USER_REQUEST, loginUserRequest),
        takeLatest(LOGIN_USER_REQUEST_SUCCESS, getUser),
        takeEvery(GET_PROJECTS_REQUEST, getProjectsRequest),
        takeLatest(REGISTER_USER_REQUEST, registerCustomer),
        takeLatest(CREATE_PROJECT_REQUEST, createProjectRequest),
        takeLatest(GET_EQUIPMENT_REQUEST, getEquipment),
        takeLatest(CREATE_EQUIPMENT_REQUEST, createEquipment),
        takeLatest(GET_USERS_REQUEST, getUsers), 
        takeLatest(CREATE_USER_REQUEST, createUser),
        takeLatest(DELETE_USER_REQUEST, deleteUser),
        takeLatest(ACCEPT_INVITE_REQUEST, acceptInvite),
        takeLatest(GET_CONTRACTORS_REQUEST, getContractors),
        takeLatest(CREATE_CONTRACTOR_REQUEST, createContractor),
        takeLatest(CREATE_CONTRACTOR_REQUEST_SUCCESS, getContractors),
    ]);
}